/**
 * Returns a string with the first character as upper case
 * @param input {string}
 */
export const ucFirst = (input: string): string => {
    if (input.length > 1) {
        return input.charAt(0).toUpperCase() + input.substr(1);
    }
    return input.toUpperCase();
};



// WEBPACK FOOTER //
// ./src/core/util/uc-first.ts